import { palette } from '@setup/theme/palette';
import theme from '@setup/theme/theme';

import type { SxProps, Theme } from '@mui/material';
import type { MuiBaseTextFiledInputVariant } from '@shared/ui-kit/inputs/MuiBaseTextFiled/MuiBaseTextFiled';

type ParamsType = {
  inputVariant: MuiBaseTextFiledInputVariant | undefined;
  withButton?: boolean;
  inputStyles?: SxProps<Theme>;
  multiline?: boolean;
  isReadOnly?: boolean;
};

export const textFilledStylesVariant = (params: ParamsType) => {
  const {
    isReadOnly = false,
    withButton = false,
    inputStyles = {},
    inputVariant,
    multiline = false,
  } = params;

  if (withButton) {
    return {
      '.input-root': {
        p: '8px 0px 8px 10px',
      },
      '.button-root': {
        borderRadius: '0px 5px 5px 0',
      },
    };
  } else if (inputVariant === 'text') {
    return {
      '& .MuiInputBase-root': {
        height: multiline ? '' : '32px',
        gap: '6px',
        padding: '6px',
        input: {
          ...inputStyles,
        },
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'transparent',
        borderRadius: '4px',
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none !important',
        },
        '&:hover  .MuiOutlinedInput-notchedOutline': {
          backgroundColor: isReadOnly ? 'none' : theme.palette.case.neutral.n75,
        },

        '& .MuiOutlinedInput-input:not(:placeholder-shown)': { color: palette.case.neutral.n800 },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          backgroundColor: isReadOnly ? 'none' : theme.palette.case.neutral.n100,
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          backgroundColor: 'transparent',
        },

        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: theme.palette.case.neutral.n400,
        },

        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          backgroundColor: palette.case.red.r100,
        },
      },
    };
  } else if (inputVariant === 'search') {
    return {
      '& .MuiInputBase-root': {
        height: '36px',
        input: {
          ...inputStyles,
        },
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.case.neutral.n100,
        borderRadius: '4px',
        color: theme.palette.case.neutral.n500,
        border: `1px solid transparent`,
        svg: {
          path: {
            fill: theme.palette.case.neutral.n500,
          },
        },

        '& .MuiInputBase-input': {
          color: theme.palette.case.neutral.n500,
        },

        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none !important',
        },

        '&:hover .MuiOutlinedInput-notchedOutline': {
          backgroundColor: theme.palette.case.neutral.n100,
        },

        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            backgroundColor: theme.palette.case.neutral.n0,
          },

          svg: {
            path: {
              fill: theme.palette.case.neutral.n600,
            },
          },

          '& .MuiInputBase-input': {
            color: theme.palette.case.neutral.n600,
          },

          border: `1px solid ${theme.palette.case.aquamarine.a600}`,
        },
        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          border: 'none !important',
          backgroundColor: theme.palette.case.neutral.n75,
        },
      },
    };
  } else if (inputVariant === 'withScroll') {
    return {
      '& .MuiInputBase-root': {
        overflowY: 'auto',

        '& ::-webkit-scrollbar': {
          width: '4px !important',
          borderRadius: '8px',
        },
        '& ::-webkit-scrollbar-track': {
          backgroundColor: theme.palette.case.neutral.n100,
          margin: '2px 0',
          borderRadius: '8px',
        },
        '& ::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.case.neutral.n300,
          borderRadius: '8px',
        },
        '& .MuiInputBase-input': {
          padding: '4px 4px 4px 0',
        },
      },
    };
  }
  return undefined;
};
